import intl from 'react-intl-universal';
import { useEffect, useState } from 'react';
import { TreeSelect, Cascader } from 'antd';
import type { TreeProps } from 'antd/es/tree';
// import { DivideClassify } from '@/type/systemSetting';
import style from '../index.less';
import { getAllProductCategory } from '@/api/common';

interface Props extends TreeProps {
    isTreeSelect: boolean;
    value: string;
    onChange: (value: string) => void;
    onSelect: (value: string | number, node: any) => void;
    readonly?: boolean;
}

const GoodsAttribute: React.FC<Props> = (props) => {
    const {
        value,
        isTreeSelect = false,
        onChange,
        onSelect,
        readonly,
        // multiple = false,
        className,
        ...other
    } = props;
    const [treeData, setTreeData] = useState<Props['treeData']>([]);
    const [initValue, setInitValue] = useState<any[]>([]);

    useEffect(() => {
        getGoodsAttributeInfo();
    }, []);

    useEffect(() => {
        setInitValue(get_level_all(treeData, value).reverse());
    }, [value]);

    // 获取树数据
    const getGoodsAttributeInfo = () => {
        getAllProductCategory().then(({ data }) => {
            if (data) {
                // setTreeData(handleTreeData(data));
                setTreeData(data);
                setInitValue(get_level_all(data, value).reverse());
            }
        });
    };
    // 处理树数据，非叶子结点不可点击添加disabled
    // const handleTreeData = (tree: DivideClassify[]): any => {
    //     return tree.map((item: DivideClassify) => {
    //         let disabled = false;

    //         if (
    //             isTreeSelect &&
    //             ((item.child_list?.length > 0 && !multiple) || item.level === 1)
    //         ) {
    //             disabled = true;
    //         }

    //         return {
    //             ...item,
    //             disabled,
    //             child_list: item.child_list
    //                 ? handleTreeData(item?.child_list)
    //                 : [],
    //         };
    //     });
    // };

    const get_level_all = (data: any[], id: number, arr = [], nameArr = []) => {
        data.find((item: any) => {
            if (item.id === id) {
                arr.push(item.id);
                return true;
            } else if (item.child_list?.length) {
                get_level_all(item.child_list, id, arr, nameArr);
                if (arr.length) {
                    arr.push(item.id);
                    return true;
                } else {
                    return false;
                }
            }
            return false;
        });
        return arr;
    };

    const onFocus = () => {
        if (!treeData?.length) {
            getGoodsAttributeInfo();
        }
    };

    return readonly ? (
        <div>{value}</div>
    ) : !isTreeSelect ? (
        <Cascader
            placeholder={intl.get('请选择商品属性')}
            allowClear
            value={initValue}
            options={treeData}
            showSearch={true}
            fieldNames={{
                label: 'name',
                value: 'code',
                children: 'child_list',
            }}
            onFocus={onFocus}
            multiple={props?.multiple || false}
            onChange={(val: any, selectedOptions: any[]) => {
                let value: any = [];
                if (props?.multiple) {
                    val?.forEach((item: any) => {
                        value.push(item[item.length - 1]);
                    });
                } else {
                    value = val?.[val?.length - 1] || undefined;
                }
                if (val) {
                    onChange(value);
                    onSelect?.(
                        value,
                        props?.multiple
                            ? selectedOptions
                            : selectedOptions[selectedOptions.length - 1],
                    );
                    setInitValue(val);
                } else {
                    onChange(value);
                    onSelect?.(value, null);
                    setInitValue([]);
                }
            }}
            className={className}
            // 这个组件展示不需要其他的属性，如果要加，把 other 里面的 getPopupContainer 属性剔除掉，创建工单会有问题
            // {...other}
        />
    ) : (
        <TreeSelect
            // width="md"
            className={`${className || ''} ${style.categoryTreeSelect}`}
            value={value}
            placeholder={intl.get('请选择商品属性')}
            allowClear
            treeData={treeData}
            treeDefaultExpandAll
            showSearch={true}
            // popupMatchSelectWidth={false}
            treeNodeFilterProp="name"
            multiple={props?.multiple || false}
            treeCheckable={props?.multiple || false}
            virtual={true}
            fieldNames={{
                label: 'name',
                value: 'code',
                children: 'child_list',
            }}
            onChange={onChange}
            onSelect={onSelect}
            onFocus={onFocus}
            {...other}
        />
    );
};

export default GoodsAttribute;
